import React from 'react';

import styled from 'styled-components';

import {
  useBreakpoint,
  SavageMarkLogo,
  mobile,
} from '~/techstyle-shared/react-components';

const Header = styled.header`
  display: flex;
  justify-content: center;

  margin: 13px 0;

  ${mobile`
    margin: 17px 0;
  `}
`;

export default function SimpleHeaderTemplateSavage() {
  const { mobile } = useBreakpoint();
  const width = mobile ? 16 : 22;
  return (
    <Header>
      <SavageMarkLogo width={width} />
    </Header>
  );
}
